import creditCardType from 'credit-card-type';
import {find} from 'lodash';
import imageAmexCard from 'payment-icons/svg/flat/amex.svg';
import imageDefaultCard from 'payment-icons/svg/flat/default.svg';
import imageDiscoverCard from 'payment-icons/svg/flat/discover.svg';
import imageMastercardCard from 'payment-icons/svg/flat/mastercard.svg';
import imageVisaCard from 'payment-icons/svg/flat/visa.svg';
import imageAmex from 'payment-icons/svg/single/amex.svg';
import imageDiscover from 'payment-icons/svg/single/discover.svg';
import imageMastercard from 'payment-icons/svg/single/mastercard.svg';
import imageVisa from 'payment-icons/svg/single/visa.svg';
import React from 'react';
import {Image} from 'semantic-ui-react';
import {CardBrands} from '../api/generated/enums';
import {validateEnumOptions} from '../api/generated/utils';
import {CardInfo} from '../gateways/types';
import {guard} from '../utils/guard';

type CardBrandImage = {
  type: CardBrands | string;
  hideUnknown?: boolean;
  logoOnly?: boolean;
  className?: string;
};

const cardImages = {
  Visa: {
    card: imageVisaCard,
    logo: imageVisa,
  },
  Mastercard: {
    card: imageMastercardCard,
    logo: imageMastercard,
  },
  Amex: {
    card: imageAmexCard,
    logo: imageAmex,
  },
  Discover: {
    card: imageDiscoverCard,
    logo: imageDiscover,
  },
};

export const CardBrandImage: React.FC<CardBrandImage> = (props) => {
  const type = cardImages[props.type];

  if (!type && (props.hideUnknown || props.logoOnly)) {
    return null;
  }

  const src = type ? (props.logoOnly ? type.logo : type.card) : undefined;

  return <Image src={src || imageDefaultCard} className={props.className} />;
};

const defaultCardBrand: CardInfo = {type: 'Unknown'};

const creditCardTypeMap = {
  'American Express': CardBrands.Amex,
};

const binInfoCache = {};
export const fetchBinInfo = guard((cardConnectToken: string) => {
  const cardBrandInput = cardConnectToken.substring(1, 3);
  if (binInfoCache[cardBrandInput]) {
    return binInfoCache[cardBrandInput] as CardInfo;
  }
  const results = creditCardType(cardBrandInput);

  const knownCardType = find(results, (x) =>
    validateEnumOptions(CardBrands, creditCardTypeMap[x.niceType] || x.niceType)
  );

  if (!knownCardType) {
    throw new Error(`Unable to find card type for ${cardBrandInput}`);
  }

  const result = {
    type: creditCardTypeMap[knownCardType.niceType] || knownCardType.niceType,
  };

  binInfoCache[cardBrandInput] = result;

  return result as CardInfo;
}, defaultCardBrand);
